module.exports = __webpack_public_path__ + "img/tawa-footer.96788dd1.svg";